import "./App.css";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Homepage from "./Components/Homepage";
import { BrowserRouter, Routes, Route,Navigate, useLocation } from "react-router-dom";
import Navy from "./Components/Navy";
import Footer from "./Components/Footer";
import Login from "./Components/Login";
import Signup from "./Components/Signup";
import About from "./Components/About";
import Contact from "./Components/Contact";
import Courses from "./Components/Courses";
import Payment from "./Components/Payment";
import ForgetPassword from "./Components/ForgetPassword";
import Dashboard from "./Components/Dashboard";
import Quiz from "./Components/Quiz";
import CodingButton from "./Components/CodingButton";
import ReviewPage from "./Components/ReviewPage";
import StudentReport from "./Components/StudentReport";
import FeedbackOption from "./Components/FeedbackOption";
import Compaydetail from "./Components/Companydetail";
import DailyQuest from "./Components/DaliyQuest";
import AdminLogin from "./Components/AdminLogin";
import HR from "./Components/HR"
import Aptitude from "./Components/Aptitude"
import AdminDashboard from "./Components/AdminDashboard";
import Badgetemplate from "./Components/Badgestemplate";
import NotFound from "./Components/NotFound";
import ServerFailureMatrix from "./Components/ServerError";
import Adaptive from "./Components/Adaptive";
import AdaptiveForm from "./Components/AdaptiveForm";
import DashboardNavbar from "./Components/DashboardNavbar";
import AdaptiveReport from "./Components/AdaptiveReport";
import ChatbotWidget from "./Components/Chatbotwidget";
import Personalitydevelopement from "./Components/Personalitydevelopement";
import LoadingMock from "./Components/Loadingmock";
import MockInterviewSetup from "./Components/questionmock";
import { MediaStreamProvider } from "./Components/Mediastreamcontext";
import DirectChat from "./Components/Interview";
import MockReport from "./Components/MockReport";
import Personalitydev from "./Components/Personalitydev"
import PrivacyPolicy from "./Components/Privacy";
import DSA from "./Components/Coursecomp";
import Navbar from "./Components/Practicenavbar";

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login"  />;
  }

  return children;
}


function Layout() {
  const location = useLocation();

  //for preventing on popup on adminlogin page
  const isAdminLoginPage = location.pathname.startsWith("/adminlogin");
  const isQuizPage = location.pathname.startsWith("/quiz");


  const hideNavbarRoutes = [
    "/front",
    "/quiz",
    "/coding",
    "/review",
    "/report",
    "/feedback",
    "/daily",
    "/adminlogin",
    "/hr",
    "/aptitude",
    "/AdminDashboard",
    "/badge",
    "/adaptive",
  "/adaptiveform",
  "/dashnav",
  "/mockinterview",
  "/personalitydevelopement",
  "/interview",
  "/mockquestion",
  "/mockreport",
  "/personalitydev",
  "/privacy-policy",
  "/dsa",
  "/practice",
  ];
  
  const fromDashboard = sessionStorage.getItem("fromDashboard");

const hideNavbar =
  hideNavbarRoutes.some((path) => location.pathname.startsWith(path)) ||
  (location.pathname.startsWith("/courses") && fromDashboard === "true");

  // ❌ Footer hide karna in routes par
  const hideFooterRoutes = [
    "/front",
    "/quiz",
    "/forget",
    "/payment",
    "/coding",
    "/review",
    "/report",
    "/login",
    "/signup",
    "/feedback",
    "/daily",
    "/adminlogin",
    "/hr",
    "/aptitude",
    "/AdminDashboard",
    "/badge",
    "/servererror",
     "/adaptive",
     "/adaptiveform",
     "/dashnav",
     "/mockinterview",
     "/personalitydevelopement",
     "/interview",
     "/mockquestion",
     "/mockreport",
       "/personalitydev",
       "/privacy-policy",
       "/dsa",
       "/practice",
  ];

  // to hide chat icon on specific routes

  const hidehchaticon = [
"/interview",
"/mockquestion",
"/mockinterview",
"/personalitydevelopement",
"/mockreport",
"/daily",
"/practice",
"/quiz",
"/adaptive",
"/adaptiveform",
"/AdminDashboard",
  ];

  const hidechat = hidehchaticon.some((path) => location.pathname.startsWith(path));


  const hideFooter = hideFooterRoutes.some((path) =>
    location.pathname.startsWith(path),
  );

  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");

    // ✅ login ho gaya → kuch nahi dikhana
    if (token) return;

    // ✅ kuch pages pe nahi dikhana
    if (
      location.pathname.startsWith("/front") ||
      location.pathname.startsWith("/daily") ||
      location.pathname.startsWith("/adminlogin") ||
      location.pathname.startsWith("/adminDashboard") ||
      location.pathname.startsWith("/badge")
    ) return;

    // 🔥 HAR 3 SEC POPUP
    const interval = setInterval(() => {
      setShowPopup(true);

      // 🔥 auto close after 5 sec
      setTimeout(() => {
        setShowPopup(false);
      }, 5000);

    }, 3000);

    return () => clearInterval(interval);
  }, [location.pathname]);


  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      setShowPopup(false); // 🔥 force close
    }
  }, []);


  useEffect(() => {
    if (showPopup) {
      const timer = setTimeout(() => {
        setShowPopup(false);
      }, 5000); // 5 sec me band

      return () => clearTimeout(timer);
    }
  }, [showPopup]);

  const handleGiveTest = () => {
    const token = localStorage.getItem("token");

    if (!token) {
      localStorage.setItem("fromPopup", "true");
      navigate("/signup");
    } else {
      navigate("/courses");
    }
  };

  const token = localStorage.getItem("token");

useEffect(() => {
  if (!location.pathname.startsWith("/courses")) {
    sessionStorage.removeItem("fromDashboard");
  }
}, [location.pathname]);


  return (
    <>
      {/* ✅ YAHAN USE KARNA HAI */}
      <MediaStreamProvider>
      {!hideNavbar && <Navy />}
      <Routes>

        {/* no route NotFound */}
        <Route path="*" element={<NotFound/>} />

        {/* server error */}
        <Route path="/servererror" element={<ServerFailureMatrix/>} />
        
        <Route path="/" element={<Homepage />} />
          <Route path="/dsa" element={<DSA/>} />
        <Route path="/login" element={<Login />} />
         <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/about" element={<About />} />
         <Route path="/mockreport" element={<MockReport />} />
        <Route path="/mockquestion" element={<MockInterviewSetup />} />
        <Route path="/mockinterview/loading" element={<LoadingMock />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/mockinterview" element={<DirectChat/>} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/personalitydevelopement" element={<Personalitydevelopement/>} />
        <Route path="/forget" element={<ForgetPassword />} />
        <Route path="/front" element={<Dashboard />} />
        <Route path="/feedback" element={<FeedbackOption></FeedbackOption>} />
        <Route path="/coding" element={<CodingButton />} />
         <Route path="/practice" element={<Navbar/>} />
       <Route
  path="/quiz"
  element={
    <ProtectedRoute>
      <Quiz />
    </ProtectedRoute>
  }
/>
        <Route path="/adaptive" element={<Adaptive/>} />
        <Route path="/adaptiveform" element={<AdaptiveForm/>} />
        <Route path="/review/:testName" element={<ReviewPage />} />
        <Route path="/report" element={<StudentReport />} />
        <Route path="/company" element={<Compaydetail />} />
        <Route path="/daily" element={<DailyQuest />} />
          <Route path="/dashnav" element={<DashboardNavbar/>}/>
        <Route path="/AdminLogin" element={<AdminLogin />} />
        <Route path="/adminDashboard" element={<AdminDashboard />} />
        <Route path="/hr" element={<HR></HR>}></Route>
        <Route path="/adaptivereport" element={<AdaptiveReport/>}/>
        <Route path="/aptitude" element={<Aptitude></Aptitude>}></Route>
        <Route path="/badge/:slug" element={<Badgetemplate />}/>
        <Route path="/personality" element={<Personalitydevelopement/>}/>
        <Route path="/personalitydev" element={<Personalitydev/>}/>



      </Routes>
      </MediaStreamProvider>
         {!hidechat && <ChatbotWidget />}

      {/* 👇 Footer conditionally render */}

      {!hideFooter && <Footer />}


      {!showPopup && !isAdminLoginPage && !isQuizPage  && !AdminDashboard && !token && (
        <div
          onClick={() => setShowPopup(true)}
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            width: "60px",
            height: "60px",
            borderRadius: "50%",
            background: "#7c3aed",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontSize: "24px",
            cursor: "pointer",
            zIndex: 9999,
          }}
        >
          💬
        </div>
      )}

      {showPopup && !isAdminLoginPage && !isQuizPage  && !AdminDashboard && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            width: "280px",
            background: "#111827",
            color: "#fff",
            borderRadius: "15px",
            padding: "15px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
            zIndex: 9999,
            animation: "slideUp 0.3s ease",
          }}
        >
          <p style={{ fontSize: "14px" }}>
            👋 Hey! Ready to test your skills?
          </p>

          <button
            onClick={handleGiveTest}
            style={{
              marginTop: "10px",
              width: "100%",
              padding: "10px",
              borderRadius: "10px",
              border: "none",
              background: "linear-gradient(135deg,#7c3aed,#a855f7)",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            Give Test 📑
          </button>

          <span
            onClick={() => setShowPopup(false)}
            style={{
              position: "absolute",
              top: "8px",
              right: "10px",
              cursor: "pointer",
            }}
          >
            ✖
          </span>
        </div>
      )}

    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;